import { makeAutoObservable } from 'mobx';
import {t} from 'shared/core';
import AwsFileStore from 'shared/stores/documents/AwsFileStore';
import _ from 'lodash';

const MAX_FILE_SIZE = 50 * 1024 * 1024;

class UploadFilesState {
  store = new AwsFileStore();
  callbacks;
  accept;
  maxFiles = -1;
  modelType;

  files;
  errorMessage;
  maxFileSizeErrorMessage;
  isUploading = false;
  dropzoneVisible = true;
  disabled = false;
  uploadToAws;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({
    accept, defaultFiles = [], maxFiles, isUploading, errorMessage,  onChange,
    onUploadStarted, onUploadFinished, modelType, disabled, uploadToAws = true
  }) {
    this.callbacks = {
      onChange,
      onUploadStarted,
      onUploadFinished
    };
    this.errorMessage = errorMessage;
    this.isUploading = isUploading;
    this.maxFiles = maxFiles;
    this.accept = accept;
    this.modelType = modelType;
    this.disabled = disabled;
    this.uploadToAws = uploadToAws;

    this.files ||= defaultFiles;
    this.dropzoneVisible = !this.hasFiles && !this.isUploading;
  }

  async __uploadFiles(files, modelType) {
    for (const f of files) {
      if (f.size > MAX_FILE_SIZE) {
        this.maxFileSizeErrorMessage = t(
          'components.dropzone.MAX_FILE_SIZE_ERROR_MESSAGE', {maxFileSizeText: '50 MB'}
        );
        return;
      }
    }

    for (const f of files) {
      const awsFile = await this.store.uploadFile(f, modelType);
      this.files.push(awsFile);
    }
  }

  async addFiles(files) {
    if (_.isEmpty(files)) return;

    this.isUploading = true;
    this.callbacks.onUploadStarted && this.callbacks.onUploadStarted();
    this.maxFileSizeErrorMessage = '';

    this.hideDropzone();

    if (this.uploadToAws) {
      await this.__uploadFiles(files, this.modelType);
    } else {
      for (const f of files) {
        this.files.push(f);
      }
    }

    this.callbacks.onChange(this.files);

    this.isUploading = false;
    this.callbacks.onUploadFinished && this.callbacks.onUploadFinished();
  }

  showDropzone() {
    this.dropzoneVisible = true;
  }

  hideDropzone() {
    this.dropzoneVisible = false;
  }

  removeFile(file) {
    this.files.remove(file);

    this.callbacks.onChange(this.files);
  }

  get hasFiles() {
    return !!this.files.length;
  }

  get canAddFiles() {
    return !this.dropzoneVisible && this.multipleFiles;
  }

  get multipleFiles() {
    return this.maxFiles !== 1;
  }
}

export default UploadFilesState;
